<template>
  <div class="bm" id="allmap"></div>
</template>
<script>
import Vue from 'vue';
import router from '../../../router';
import { BMPGL } from "@/util/bmpgl.js";
import { mapGetters } from "vuex";
import agriculturalInfoWindow from '../../productionService/components/agriculturalInfoWindow.vue';
import { offsetLocation } from '../../../js/utils/util';
import {getSupplyInfoOfMaterials, getSupplyInfoOfService} from "@/api/supplyDemand.js";
export default {
  props: ["projectList"],
  data() {
    return {
      ak: window.global.bmKey,
      lon: window.global.view.center[0],
      lat: window.global.view.center[1],
      zoom: 12,
      icon: require("../../../assets/地块1.png"),//标记点使用的图标
      icon2: require('../../../assets/农服商.png'),
      icon3: require('../../../assets/农资商.png'),
      progressList: [],
      YTZYList: [],
      doneList: [],
      map: null,
      BMapGL: null,
      currentInfoWindow: null,
      markers: [],
      baseUrl: window.globalUrl.HOME_API,
      pageSize: 500,
    };
  },
  computed: {
    ...mapGetters(["topSelectAreacode", 'topSelectAreaname','identityObj', 'topSelectAreaCenterPoint']),
  },
  watch: {
    topSelectAreaname: function () {
      this.setMapCenter(this.topSelectAreaCenterPoint)
      this.clearMarkers();
      this.getAgriculturalList();
    }
  },
  mounted() {
    this.initMap();
    this.getAgriculturalList();
    this.setMapCenter(this.topSelectAreaCenterPoint)
  },
  methods: {

    // 根据地区名称设置地图中心点
    async setMapCenter(centerPoint) {

      if (!centerPoint) return;

        const [lon, lat] = centerPoint.split(',');
        if (this.map) {
          const point = new this.BMapGL.Point(lon, lat);
          this.map.centerAndZoom(point, this.zoom);
          this.lon = lon;
          this.lat = lat;
        }

      // if (!this.BMapGL) return;

      // const geocoder = new this.BMapGL.Geocoder();
      // geocoder.getPoint(areaName, point => {
      //   if (point) {
      //     this.map.centerAndZoom(point, this.zoom);
      //     // 如果需要保存最新中心点
      //     this.lon = point.lng;
      //     this.lat = point.lat;
      //     // console.log(this.lon, this.lat, '打印位置信息')
      //   }
      // }, "全国"); // 可以指定省市区提升准确性
    },
    initMap() {
      // 传入密钥获取地图回调。
      BMPGL(this.ak)
        .then((BMapGL) => {
          // 创建地图实例
          let map = new BMapGL.Map("allmap");
          // 创建点坐标 axios => res 获取的初始化定位坐标
          let point = new BMapGL.Point(this.lon, this.lat);

          map.setMapType(BMAP_SATELLITE_MAP);

          var styleJson = [{
              "featureType": "transit", // 例如，隐藏公交站
              "elementType": "labels",
              "stylers": {
                  "visibility": "off"
              }
            },
            // 隐藏商业区域标签
            {
              "featureType": "poi",
              "elementType": "labels",
              "stylers": {"visibility": "off"}
            },
            // 隐藏水系标签
            {
              "featureType": "water",
              "elementType": "labels",
              "stylers": {"visibility": "off"}
            },
            // 隐藏道路标签（路标）
            {
              "featureType": "road.label",
              "elementType": "labels",
              "stylers": {
                "visibility": "off"
              }
            },
            // 隐藏植被区域（树林）
            {
              "featureType": "vegetation",
              "elementType": "all",
              "stylers": {
                "visibility": "off"
              }
            }
          ];
          map.setMapStyleV2({styleJson: styleJson}); // 应用自定义样式

          // 初始化地图，设置中心点坐标和地图级别
          map.centerAndZoom(point, this.zoom);
          //开启鼠标滚轮缩放
          map.enableScrollWheelZoom(true);
          // 添加缩放控件
          var zoomCtrl = new BMapGL.ZoomControl();
          map.addControl(zoomCtrl);
          map.setMaxZoom(17);

          // 保存数据
          this.BMapGL = BMapGL;
          this.map = map;
        })
        .catch((err) => {
          console.log(err);
        });
    },
      /**
       * 获取农资商数据

       */
      async getAgriculturalList() {
        try {
          const firstPage = await getSupplyInfoOfMaterials({
            pnum: 1,
            psize: this.pageSize,
            areaCode: this.topSelectAreacode
          });
          if (firstPage.data?.length) {
            this.addAgriculturalMarkers(firstPage.data);
          }
          const sumCount = firstPage.dataNum;
          const totalPage = Math.ceil(sumCount / this.pageSize);
          // 使用setTimeout异步加载剩余页数据
          for (let i = 2; i <= totalPage; i++) {
            setTimeout(async () => {
              const pageData = await getSupplyInfoOfMaterials({
                pageNo: i,
                pageSize: this.pageSize,
                areaCode: this.areaCode
              });
              if (pageData.data?.length) {
                this.addAgriculturalMarkers(pageData.data);
              }
            }, (i-1) * 500); // 每页间隔500ms加载
          }

        } catch (error) {
          console.error('数据获取失败:', error);
        }
      },

       /**
       *
       * @param dataList 绘制农资商标点
       */
       addAgriculturalMarkers(dataList) {
        if (!dataList || !this.BMapGL) return;
        const BMapGL = this.BMapGL;
        const markerIcon = new BMapGL.Icon(
          this.icon3,
          new BMapGL.Size(25, 40)
        );
        markerIcon.setImageSize(new BMapGL.Size(25, 30));
        // console.log(dataList, '查看农资商dataList')
        const coordMap = new Map();
        dataList.forEach((ele) => {

           //处理偏移量
           const key = `${ele.longitude},${ele.latitude}`;
          const count = coordMap.get(key) || 0;
          coordMap.set(key, count + 1);

          // 计算偏移后的点坐标
          let location = offsetLocation(count, ele.longitude, ele.latitude);

          let pt = new BMapGL.Point(location.lng, location.lat);
          let marker = new BMapGL.Marker(pt, { icon: markerIcon });
          marker.AgriculturaData = ele;
          marker.addEventListener('click', e => {
              this.showAgriculturaInfo(e.target);
          });
          this.markers.push(marker);
          this.map.addOverlay(marker);

        });
      },

      showAgriculturaInfo(marker) {
        if (this.currentInfoWindow) {
          this.map.closeInfoWindow(this.currentInfoWindow);
        }
        const info = marker.AgriculturaData;
        console.log(info, '查看农资info')

        const ComponentClass = Vue.extend(agriculturalInfoWindow);
        const instance = new ComponentClass({
          router,
          propsData: {
            info,
          },
        });
        const content = instance.$mount().$el;

        this.currentInfoWindow = new BMapGL.InfoWindow(content, {
          width: 300,
          height: 100,
          offset: new BMapGL.Size(0, -10)
        });
        this.map.openInfoWindow(this.currentInfoWindow, marker.getPosition());
      },

      clearMarkers() {
        this.markers.forEach((marker) => {
          this.map.removeOverlay(marker);
        });
        if (this.currentInfoWindow) {
          this.map.closeInfoWindow(this.currentInfoWindow);
        }
      },

    // back() {
    //   this.initMap();
    // },
  },
};
</script>
<style lang="less" scoped>
.bm {
  width: 100%;
  height: 100%;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;

  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.boxTitle {
  font-size: 16px;
  color: #00aeee;
  font-weight: 600;
}
/deep/ .anchorBL {
  display: none;
}

/deep/ .BMap_bubble_buttons {
  display: none;
}
</style>
